import { Component, Input } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { OneTimeAccessToken, OneTimeAccessTokenFromJSON } from 'elements-sdk'

@Component({
  templateUrl: './oneTimeAccessTokenModal.component.pug',
})
export class OneTimeAccessTokenModalComponent {
  @Input() token: OneTimeAccessToken

  constructor (public modalInstance: NgbActiveModal) { }

  ngOnChange () {
    if ('created_by' in this.token) {
      this.token = OneTimeAccessTokenFromJSON(this.token)
    }
  }
}
